import { Database, Code, Shield, Zap, Lock, Target, Users, Globe } from 'lucide-react';

export const platformPillars = [
  {
    icon: <Database size={32} />,
    title: "MCP Protocol",
    description: "Model Context Protocol enables seamless integration across AI tools and frameworks. Connect AI agents to enterprise data with standardized interfaces."
  },
  {
    icon: <Code size={32} />,
    title: "Agent Builder",
    description: "Create LLM-powered agents through intuitive interfaces. Build autonomous workflows that connect AI to your business logic."
  },
  {
    icon: <Shield size={32} />,
    title: "Security & Governance",
    description: "Enterprise-grade security and compliance. Run AI on your private network with complete control and auditability."
  },
  {
    icon: <Zap size={32} />,
    title: "Operations",
    description: "Connect AI directly to operational systems. Enable real-time decision-making with human + AI collaboration patterns."
  }
];

export const keyFeatures = [
  {
    icon: <Lock size={20} />,
    title: "Private Network Deployment",
    description: "Run LLMs and AI agents on your private infrastructure with complete data sovereignty and security."
  },
  {
    icon: <Target size={20} />,
    title: "AI-Driven Decision Making",
    description: "Power real-time operational decisions in critical commercial and government contexts worldwide."
  },
  {
    icon: <Users size={20} />,
    title: "Human + AI Teaming",
    description: "Enable seamless collaboration between human operators and AI agents for enhanced productivity."
  },
  {
    icon: <Globe size={20} />,
    title: "Multimodal AI Mesh",
    description: "Deploy comprehensive AI solutions from web applications to edge devices with localized AI."
  }
];

export const useCases = [
  {
    title: "Supply Chain Optimization",
    industry: "Manufacturing",
    description: "AI agents monitor global supply chains, predict disruptions, and automatically adjust procurement strategies in real-time."
  },
  {
    title: "Fraud Detection & Prevention",
    industry: "Financial Services", 
    description: "Deploy autonomous agents that analyze transaction patterns and flag suspicious activities with explainable AI reasoning."
  },
  {
    title: "Clinical Decision Support",
    industry: "Healthcare",
    description: "Medical AI agents assist clinicians with diagnosis, treatment recommendations, and patient care optimization."
  },
  {
    title: "Cybersecurity Operations",
    industry: "Government & Defense",
    description: "Intelligent agents continuously monitor networks, detect threats, and orchestrate automated response protocols."
  },
  {
    title: "Resource Planning & Allocation",
    industry: "Energy & Utilities",
    description: "Optimize resource distribution and energy allocation through predictive AI agents and real-time analytics."
  },
  {
    title: "Customer Experience Management",
    industry: "Retail & Commerce",
    description: "Autonomous customer service agents handle inquiries, personalize experiences, and predict customer needs."
  }
];